import {
  ApplicationRef,
  ChangeDetectorRef,
  Directive,
  ElementRef,
  EventEmitter,
  Inject,
  Injector,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';
import {NgbPopover, NgbPopoverConfig} from "@ng-bootstrap/ng-bootstrap";
import {DOCUMENT} from '@angular/common';

const timeout = 300;

@Directive({
  selector: '[stickyPopover]',
  exportAs: 'stickyPopover'
})
export class StickyPopover extends NgbPopover implements OnInit, OnDestroy {
  @Input() stickyPopover: TemplateRef<any>;

  @Output() outMouseEnterPopover = new EventEmitter();
  @Output() outMouseLeavePopover = new EventEmitter();

  canClosePopover: boolean;
  openTimeout: any;

  constructor(
    private _elRef: ElementRef,
    private _render: Renderer2,
    injector: Injector,
    viewContainerRef: ViewContainerRef,
    config: NgbPopoverConfig,
    _ngZone: NgZone,
    @Inject(DOCUMENT) _document: any,
    _changeDetector: ChangeDetectorRef,
    applicationRef: ApplicationRef) {
    super(_elRef, _render, injector, viewContainerRef, config, _ngZone, _document, _changeDetector, applicationRef);
  }

  ngOnDestroy() {
    super.close();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.ngbPopover = this.stickyPopover;

    this._render.listen(this._elRef.nativeElement, 'mouseenter', () => {
      this.canClosePopover = true;
      this.openTimeout = setTimeout(() => this.open(), this.openDelay);
    });

    this._render.listen(this._elRef.nativeElement, 'mouseleave', (event: Event) => {
      clearTimeout(this.openTimeout);
      setTimeout(() => {
        if (this.canClosePopover) {
          super.close();
        }
      }, timeout);
    });
  }

  open() {
    super.open();

    this.canClosePopover = true;

    setTimeout(() => {
      const popover = window.document.querySelector(`.popover.${this.popoverClass}`);

      if (popover) {
        this._render.listen(popover, 'mouseenter', () => {
          this.outMouseEnterPopover.emit();
          this.canClosePopover = false;
        });

        this._render.listen(popover, 'mouseleave', () => {
          this.outMouseLeavePopover.emit();
          this.canClosePopover = true;
          setTimeout(() => {
            if (this.canClosePopover) {
              super.close();
            }
          });
        });
      }
    });
  }

  closeWithTimeout() {
    setTimeout(() => {
      if (this.canClosePopover) {
        super.close();
      }
    }, timeout);
  }
}
